import { init } from 'i18next'
import moment from 'moment'
import momentLanguages from '../../common/moment-languages.json'
import { Translations } from '../../../types/types'
import { isDebugTranslations } from './debug-translations'

const i18Next = (translations: Translations | undefined, language: string, environment: string) => {
  const isProduction = environment === 'production'
  // If 'translations' is undefined, enable debug mode (= show localization keys)
  const isDebugTransEnabled = isDebugTranslations()
  const isDebug = !isProduction && (!translations || isDebugTransEnabled)

  const momentLocaleKey = language.replace('_', '-')

  if (!isDebug && momentLanguages.languages.indexOf(momentLocaleKey) === -1) {
    throw new Error(
      `Tried to use Moment locale "${momentLocaleKey}", which has not been included in the bundle.
       Did you forget to add it to "moment-languages.json"?`
    )
  }

  // Default moment locale to en-GB if we're in debug translations mode
  moment.locale(isDebug ? 'en-GB' : momentLocaleKey)

  init({
    debug: !isProduction,
    defaultNS: 'app',
    // 'cimode' is a built-in language, which always shows localization keys
    lng: isDebug ? 'cimode' : language,
    ns: Object.keys(translations || {}),
    parseMissingKeyHandler: isProduction
      ? (_, defaultValue) => defaultValue ?? ''
      : (key, defaultValue) => defaultValue ?? key,
    resources: { [language]: translations || {} }
  })
}

export default i18Next
